<template>
  <a-modal :open="open" @cancel="closeForm">
    <h2>Выберите тип отчета</h2>
    <a-divider style="margin: 16px 0"/>
    <a-table
        :columns="columns"
        rowKey="id"
        :data-source="testData"
        :scroll="{ x: 200 }"
        :pagination="false"
        :locale="{ emptyText: emptySlot()}"
        :loading="tableLoading"
        :table-layout="'fixed'"
    >
      <template #bodyCell="{ column, text, record }">
        <template v-if="column.dataIndex === 'free'">
            <span class="free-quotas">
              {{ text }}
            </span>
        </template>

        <template v-if="column.dataIndex === 'current'">
          <a-checkbox v-if="record.current || !record.free"
                      :disabled="true" :checked="true"
          />
          <a-checkbox v-else v-model:checked="form[record.type]"/>
        </template>
      </template>
    </a-table>
    <template #footer>
      <a-divider />
      <div class="action-buttons">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
          </a-col>
          <a-col>
            <a-button class="primary-button" :loading="formIsLoading" @click="getNewReportTypes">Создать</a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {computed, reactive, ref} from "@vue/reactivity";
 import {onBeforeMount} from "@vue/runtime-core";
 import {h} from "vue";
 import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import {useStore} from "vuex";
import getReportName from "@/mixins/getReportName";
import {message} from "ant-design-vue";

 export default  {
   props: {
     open: Boolean,
     originalPassing: Object,
   },
   emits: ['closeForm', 'generated'],
   setup(props, context) {
     const columns = [
       {
         title: 'ТЭИ',
         dataIndex: 'product',
         key: 'product',
         width: 120,
         align: 'left',
       },
       {
         title: 'Доступно',
         dataIndex: 'free',
         key: 'free',
         width: 45,
         align: 'right',
       },
       {
         title: 'Доступ',
         dataIndex: 'current',
         key: 'current',
         width: 45,
         align: 'right',
       },
     ];

     const form = reactive({
       standard: false,
       full: false,
       management: false,
       start: false,
     });

     const store = useStore();
     const companyQuotas = computed(() => store.state.company.userQuotas);
     const testData = ref();

     onBeforeMount(() => {
       tableLoading.value = true;
       store.dispatch('company/getUserQuotas').then(() => {
         testData.value = Object.entries(companyQuotas.value.test_passings)
             .filter(([key]) => key !== 'empty')
             .map(([key, value]) => {
               return {
                 product: getReportName(key),
                 type: key,
                 free: value.free,
                 current: props.originalPassing.report_type === key || props.originalPassing.related_passings.find((el) => el.report_type === key),
               }
         });
       }).finally(() => {
         tableLoading.value = false;
       });
     })

     const emptySlot = () =>
         h('div', { class: 'no-data-wrapper' }, [
           h('img', { src: NotFoundIcon, class: 'no-data-image'}),
           h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
         ]);

     const formIsLoading = ref(false);
     const tableLoading = ref(false);

     const getNewReportTypes = () => {
       formIsLoading.value = true;

       let report_types = Object.keys(form).filter((key) => form[key] === true);

       if (!report_types.length) {
         message.error('Выберите тип отчета');
         formIsLoading.value = false;
         return;
       }

       store.dispatch('test/generateDifferentReports',{
         codes: [props.originalPassing.code],
         report_types: report_types,
       }).then(() => {
          message.success('Отчеты сгенерированы');
          context.emit('generated');
       }).catch(() => {
         message.error('Произошла ошибка');
       }).finally(() => {
         formIsLoading.value = false;
       });
     }

     const closeForm = () => {
       context.emit('closeForm');
     }

     return {
       form,
       emptySlot,
       columns,
       testData,
       closeForm,
       formIsLoading,
       getNewReportTypes,
       tableLoading
     }
   }
 }
</script>

<style scoped lang="scss">
h2 {
  margin: 0;
}
:deep(.custom-collapse-expand-icon--active) {
  transform: translateY(1px);
}

:deep(.ant-table-thead>tr>th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-thead>tr>th:not(:first-child)) {
  padding: 5px !important;
}
</style>